import {
    useTranslation,
} from 'react-i18next'
import React, {
    ReactNode,
} from 'react'
import {
    css,
} from '@emotion/react'
import IS_DEBUG from '@src/constants/isDebug'
import EN_TRANSLATION from '@src/../public/locales/en/translation.json'

const KEYS = Object.keys(EN_TRANSLATION)

export type TFn = (key: string, param?: object) => ReactNode
type Return = {
    t: TFn
}

const accountedKey = (key: string): boolean => {
    return KEYS.includes(key)
}

const useT = (): Return => {
    const {
        t,
    } = useTranslation()

    return {
        t: (key, param) => {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return IS_DEBUG && !accountedKey(key) ? <span css={css('color:red')}>{t(key, param)}</span> : <>{t(key, param)}</>
        },
    }
}

export default useT
